import styled from 'styled-components'
import COLORS from '@colors'

export const Polygon = styled.polygon`
  fill: ${COLORS.leather};
`

export const Path = styled.path`
  fill: ${COLORS.whiteFd};
`
